import React from "react";

import { ButtonIcon, type IconName } from "@orgmym/leeloo-core";

import * as styles from "./media-menu-button.css";

interface MediaMenuButtonProps {
  isOpen: boolean;
  isMobile: boolean;
  disabled?: boolean;
  defaultIcon?: IconName;
  onToggle: () => void;
  onShowKeyboard?: () => void;
  children?: React.ReactNode;
}

export const MediaMenuButton: React.FC<MediaMenuButtonProps> = ({
  isOpen,
  isMobile,
  disabled = false,
  defaultIcon = "add",
  onToggle,
  onShowKeyboard,
  children
}) => {
  const handlePress = () => {
    if (isMobile && isOpen && onShowKeyboard) return onShowKeyboard();

    const focusedInput = isMobile
      ? (document.activeElement as HTMLElement)
      : null;
    focusedInput instanceof HTMLTextAreaElement
      ? focusedInput.blur()
      : onToggle();
  };

  const iconName = (isMobile && isOpen ? "frame" : defaultIcon) as IconName;
  const ariaLabel = isMobile && isOpen ? "Show keyboard" : "Attachment";

  return (
    <div className={styles.attachmentButtonWrapper}>
      {children}
      <span
        className={styles.attachmentButtonIcon({ open: !isMobile && isOpen })}
      >
        <ButtonIcon
          iconName={iconName}
          iconSize="medium"
          variant="simple"
          size="medium"
          onPress={handlePress}
          className={styles.attachmentButton}
          disabled={disabled}
          aria-label={ariaLabel}
          data-testid="message-menu-toggle"
        />
      </span>
    </div>
  );
};

export default MediaMenuButton;
